import React, { useState } from 'react';

export const GlobalContext = React.createContext();
export const GlobalContextProvider = ({ children }) => {
  const [contextState, setContextState] = useState({});
  return <GlobalContext.Provider value={{ contextState, setContextState }}>{children}</GlobalContext.Provider>;
};
export const useGlobalContext = () => React.useContext(GlobalContext);
